var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "historic-records" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "history-main",
        },
        [
          _c(
            "div",
            { staticClass: "history-card" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "history-title flex items-center justify-between",
                },
                [
                  _c("span", [_vm._v("历史记录")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请选择", size: "small" },
                      on: { change: _vm.handleTypeChange },
                      model: {
                        value: _vm.currentValue,
                        callback: function ($$v) {
                          _vm.currentValue = $$v
                        },
                        expression: "currentValue",
                      },
                    },
                    _vm._l(_vm.typeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              !_vm.historyData || !_vm.historyData.length
                ? _c("el-empty")
                : _vm._l(_vm.historyData, function (item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "history-item flex items-start" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "item-text flex items-center justify-between",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex items-center",
                                staticStyle: {
                                  width: "calc(100% - 210px)",
                                  "flex-shrink": "0",
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  item.type === "achievement"
                                    ? _c("img", {
                                        attrs: {
                                          width: "17",
                                          height: "21",
                                          src: require("@/assets/images/GuoJiao/achievement-icon.png"),
                                          alt: "",
                                        },
                                      })
                                    : item.type === "demand"
                                    ? _c("img", {
                                        attrs: {
                                          width: "18",
                                          height: "21",
                                          src: require("@/assets/images/GuoJiao/demand-icon.png"),
                                          alt: "",
                                        },
                                      })
                                    : _c("img", {
                                        attrs: {
                                          width: "21",
                                          height: "18",
                                          src: require("@/assets/images/GuoJiao/dialog-icon.png"),
                                          alt: "",
                                        },
                                      }),
                                ]),
                                _c("p", { staticClass: "text ellipsis" }, [
                                  _c(
                                    "span",
                                    {
                                      attrs: { title: item.title },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toDetails(item)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.title || "-"))]
                                  ),
                                ]),
                              ]
                            ),
                            _c("span", { staticClass: "item-time" }, [
                              _vm._v(
                                _vm._s(
                                  item.createdTime
                                    ? _vm.formatToDateTime(item.createdTime)
                                    : "-"
                                )
                              ),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "delete pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(item)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/GuoJiao/delete-icon.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
            ],
            2
          ),
          _vm.pager.total
            ? _c(
                "div",
                { staticClass: "page-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.pager.pageNum,
                      "page-size": _vm.pager.pageSize,
                      layout: "prev, pager, next",
                      total: _vm.pager.total,
                    },
                    on: { "current-change": _vm.handleCurrentChange },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("delete-confirm", {
        attrs: {
          visible: _vm.deleteVisible,
          title: "提示",
          message: "删除后，该记录不可恢复。确认删除吗？",
        },
        on: {
          "update:visible": function ($event) {
            _vm.deleteVisible = $event
          },
          confirm: _vm.handleDeleteConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }